import * as React from 'react';

const NodeJSIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg fill="none" height={28} viewBox="0 0 27 28" width={27} xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M14.3097 0.298722C13.5999 -0.100468 12.6745 -0.0986784 11.9641 0.298722C8.40611 2.26227 4.84803
            4.22642 1.28937 6.18907C0.596895 6.55336 0.129845 7.29699 0.137295 8.06881V19.9328C0.132295
            20.7197 0.623425 21.4705 1.33376 21.8298C2.35592 22.3736 3.34901 22.9726 4.38965 23.4802C5.59172
            24.0709 7.09564 24.2015 8.31241 23.5855C9.30011 23.075 9.73881 21.9395 9.73751 20.896C9.74551
            16.9806 9.73881 13.0651 9.74061 9.14961C9.76411 8.97561 9.63341 8.78961 9.44361 8.79381C8.98891
            8.78661 8.53361 8.78961 8.07891 8.79261C7.90711 8.77641 7.73941 8.91911 7.75241 9.09181C7.74631
            12.982 7.75361 16.8734 7.74871 20.7642C7.75861 21.3024 7.39501 21.8196 6.87634 22.0014C5.67841 
            22.4213 2.25919 20.2012 2.25919 20.2012C2.13371 20.1431 2.05403 20.007 2.06633 19.8718C2.06633 
            15.9576 2.06694 12.0433 2.06633 8.12971C2.04908 7.97192 2.14633 7.82981 2.29123 7.76539C5.83754 
            5.81341 9.38201 3.85654 12.9283 1.90336C13.0515 1.82115 13.2232 1.8214 13.3461 1.90396C16.8924 
            3.85654 20.4375 5.81162 23.9844 7.76369C24.1298 7.82801 24.2229 7.97251 24.2081 8.12971C24.2075 
            12.0433 24.2093 15.9576 24.2069 19.8713C24.2174 20.0098 24.1458 20.144 24.0165 20.2048C20.5033 
            22.1462 16.9501 24.025 13.4687 26.0228C13.3168 26.1099 13.1447 26.2086 12.9745 26.1126C12.059 
            25.6062 11.1546 25.0801 10.2421 24.5688C10.1429 24.5069 10.0166 24.4803 9.91311 24.5496C9.50401 
            24.7652 9.11921 24.9398 8.64941 25.1258C7.98961 25.387 8.09501 25.4938 8.69011 25.8405C9.75721 
            26.4444 10.8261 27.0459 11.8932 27.6504C12.5957 28.0888 13.5396 28.12 14.2647 27.7149C17.8233 
            25.7538 21.3808 23.7904 24.9401 21.8293C25.6485 21.468 26.1421 20.7202 26.1371 19.9327V8.06881C26.144
            7.31265 25.6948 6.58228 25.0232 6.2126C21.4528 4.23948 17.8807 2.27064 14.3097 0.298722Z"
            fill={props.color ? props.color : 'white'}
        />
        <path
            d="M19.6791 9.20604C18.2824 8.45884 16.6208 8.41904 15.0687 8.51674C13.9474 8.62754 12.7681 
            8.93694 11.9512 9.74074C11.1133 10.5487 10.9309 11.8535 11.3289 12.9083C11.6141 13.6537
            12.332 14.1384 13.0744 14.3948C14.0307 14.7324 15.0351 14.8368 16.0398 14.9412C16.9562
            15.0364 17.8729 15.1317 18.7537 15.404C19.1135 15.5232 19.5325 15.7056 19.6427 
            16.0971C19.7445 16.5607 19.6329 17.0996 19.2565 17.4217C18.0609 18.368 14.7351 
            18.223 13.5538 17.4782C13.0762 17.1609 12.8704 16.5992 12.7867 16.0639C12.7774
            15.8971 12.6431 15.7441 12.462 15.7568C12.0085 15.7514 11.555 15.7526 11.1015
            15.7562C10.9433 15.7429 10.7788 15.8555 10.7701 16.017C10.6769 18.4687 12.9286 
            19.5375 15.0411 19.7728C16.248 19.8878 17.4814 19.8812 18.6699 19.6222C19.5633 
            19.4188 20.4591 19.0442 21.0741 18.3561C21.8325 17.5198 21.9816 16.2747 21.6415 
            15.233C21.3815 14.4557 20.6384 13.9571 19.8788 13.7006C18.8458 13.3464 17.6216 
            13.156 16.686 13.0669C15.3261 12.9374 13.7101 12.9903 13.3252 12.0967C13.1717
            11.6288 13.3023 11.0478 13.7323 10.76C14.87 9.98834 17.1855 10.0908 18.3637
            10.6673C18.9047 10.9382 19.2182 11.4946 19.3476 12.0563C19.3716 12.2213
            19.4826 12.3935 19.6736 12.3863C20.124 12.3953 20.5744 12.3887 21.0247
            12.3893C21.1794 12.4001 21.3488 12.3128 21.379 12.1544C21.3599 10.9804 
            20.7604 9.77864 19.6791 9.20604Z"
            fill={props.color ? props.color : 'white'}
        />
    </svg>
);
// fill="#8CC84B"
export default NodeJSIcon;
